import { useMutation, useQueryClient } from '@tanstack/react-query'
import createFeedbackSurvey from '../api/feedback/createFeedbackSurvey'
import { GET_FEEDBACK_SURVEY_RESPONSE_KEY } from '../constants'

const useCreateFeedbackSurvey = () => {
  const queryClient = useQueryClient()
  return useMutation(
    async (feedbackSurveyData: any) => {
      return await createFeedbackSurvey(feedbackSurveyData)
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [GET_FEEDBACK_SURVEY_RESPONSE_KEY],
        })
      },
    },
  )
}

export default useCreateFeedbackSurvey
